import { NSButton, NSSection } from "namirasoft-site-react";
import { useNavigate } from "react-router-dom";
import { SupportRoutes } from "../SupportRoutes";

export interface SupportChannelsProps
{
    ticket: boolean;
    email: boolean;
    chat: boolean;
    meeting: boolean;
}

export default function SupportChannels(props: SupportChannelsProps)
{
    const navigate = useNavigate();

    return (
        <NSSection>
            <img
                src="https://static.namirasoft.com/image/concept/bot/support.webp"
                alt="suppor"
                width="256px"
                height="256px"
            />
            <div style={{
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                gap: "16px"
            }}>
                {
                    props.ticket &&
                    <NSButton
                        title="Create a ticket"
                        onClick={{
                            action: () =>
                            {
                                navigate(SupportRoutes.TicketNew);
                            },
                            showLoading: false
                        }}
                        icon={{
                            src: "https://static.namirasoft.com/image/concept/ticket/blue.svg"
                        }}
                        style={{ background: "white", height: "64px", justifyContent: "start", paddingLeft: "16px" }}
                    />
                }
                {
                    props.email &&
                    <NSButton
                        title="support@namirasoft.com"
                        onClick={{
                            action: () =>
                            {
                                window.location.href = "mailto:support@namirasoft.com";
                            },
                            showLoading: false
                        }}
                        icon={{
                            src: "https://static.namirasoft.com/image/concept/social/email/blue.svg"
                        }}
                        style={{ background: "white", height: "64px", justifyContent: "start", paddingLeft: "16px" }}
                    />
                }
                {
                    props.chat &&
                    <NSButton
                        title="Online Chat"
                        onClick={{
                            action: () =>
                            {
                                window.open("https://tawk.to/chat/669f3bb4becc2fed692930ca/1is5ie2d7");
                            },
                            showLoading: false
                        }}
                        icon={{
                            src: "https://static.namirasoft.com/image/concept/chat/blue.svg"
                        }}
                        style={{ background: "white", height: "64px", justifyContent: "start", paddingLeft: "16px" }}
                    />
                }
                {
                    props.meeting &&
                    <NSButton
                        title="Book a meeting"
                        onClick={{
                            action: () =>
                            {
                                window.open("https://koalendar.com/e/namira-software-corporation")
                            },
                            showLoading: false
                        }}
                        icon={{
                            src: "https://static.namirasoft.com/image/concept/meeting/blue.svg"
                        }}
                        style={{ background: "white", height: "64px", justifyContent: "start", paddingLeft: "16px" }}
                    />
                }
            </div>
        </NSSection>
    );
}